import { callApi, doFetch, sortingApiMap } from 'utils';
import { getI18nLng } from 'utils/i18n';
import { CollectionModel, ctTokenModel } from 'common/api/models';

/**
 * @param {string} refreshToken
 * @param {number} userId
 * @return {Promise<ctTokenModel>}
 */
export const refreshCtTokenApi = (refreshToken, userId) => {
  let body = new FormData();
  body.append('refreshToken', refreshToken);

  return doFetch(`users/${userId}/token/refresh`, {
    body,
    method: 'POST',
  }).then(ctTokenModel);
};

export const myVideosFetchApi = ({ userId, sorting, perPage, pageNum = 1 }) => {
  const language = getI18nLng();

  return callApi(
    `users/${userId}/videos?pageNum=${pageNum}${sortingApiMap(sorting)}${
      perPage ? `&perPage=${perPage}` : ''
    }&lang=${language}`
  ).then((collection) => CollectionModel(collection));
};

export const fetchUserApi = (userId) => {
  if (userId === null || userId === undefined) {
    return null;
  }

  return callApi('users/' + userId);
};
